const getMainPhone = ({phoneCode1, phoneNumber1}) => ({phoneCountry: phoneCode1, phoneNumber: phoneNumber1});
const getSecondaryPhone = ({phoneCode2, phoneNumber2}) => ({phoneCountry: phoneCode2, phoneNumber: phoneNumber2});
const isSecondaryPhoneAvailable = (phone = {}) => Object.values(getSecondaryPhone(phone)).every((value) => value);

class ExtraInfo {
    init({bookingId = 0, buyerInfo = {}}) {
        this.bookingId = bookingId;
        this.buyer = buyerInfo;
        this.tracking = {};
    }

    setBookingId(id) {
        this.bookingId = id;
    }

    getBookingId() {
        return this.bookingId;
    }

    setBuyerInfo(info = {}) {
        Object.assign(this.buyer, info);
    }

    getBuyerInfo(key) {
        return this.buyer[key];
    }

    addTracking(tracking = {}) {
        this.tracking = {
            ...this.tracking,
            ...tracking,
        };
    }

    getTracking() {
        return this.tracking;
    }

    get buyerInfo() {
        return Object.assign({}, this.buyer);
    }

    get phone() {
        return isSecondaryPhoneAvailable(this.buyer) ? getSecondaryPhone(this.buyer) : getMainPhone(this.buyer);
    }

    get data() {
        return {
            bookingId: this.bookingId,
            buyerInfo: this.buyerInfo,
            tracking: this.tracking,
        };
    }
}

module.exports = new ExtraInfo();
